import React from 'react';
import { PillButton } from '../../ButtonPillDropdown/PillButton';
import styles from './styles.scss';

export interface PriceRange {
  label: string;
  value: string;
}

interface PriceFilterPillsProps {
  selectedPrice: string;
  onPriceChange: (price: string) => void;
}

export const PRICE_RANGES: PriceRange[] = [
  { label: '$0-$49', value: '*_49.99' },
  { label: '$50-$99', value: '50_99.99' },
  { label: '$100-$149', value: '100_149.99' },
  { label: '$150+', value: '150_*' },
];

export const PriceFilterPills: React.FC<PriceFilterPillsProps> = ({ selectedPrice, onPriceChange }) => {
  return (
    <div className={styles.priceFilterContainer} role="group" aria-label="Filter gifts by price range">
      {PRICE_RANGES.map(range => (
        <PillButton
          key={range.value}
          selected={selectedPrice === range.value}
          onClick={() => onPriceChange(range.value)}
          data-testid={`price-filter-${range.value}`}
        >
          {range.label}
        </PillButton>
      ))}
    </div>
  );
};
